import { Fragment } from 'react';
import { CtaButton } from '@components/CtaButton';
import PromoLabels from '@components/ProductCardNew/PromoLabels/PromoLabels';
import { FLAGS_TYPES_NAMES } from '@features/categories/const';
import { TProductFlagsKey } from '@features/categories/typescript/index';
import { TImage, TVideo } from '@components/typescript';
import styles from './PromoBannerBlock.styles';
import RenderMedia from '@utils/RenderMedia';
import SpacingBlock from '@features/cms/components/collections/SpacingBlock/SpacingBlock';
import theme from '@styles/theme';
import { splitTextByLineBreaks } from '@utils/splitTextByLineBreaks';
export type LabelType = 'new' | 'promotion' | 'bestseller';
export interface PromoBannerBlockData {
  title: string;
  description?: string | null;
  ctaText?: string | null;
  ctaLink?: string | null;
  image?: TImage | null;
  video?: TVideo | null;
  imageAlt?: string | null;
  labelType?: LabelType | null;
  reversed?: boolean;
  marginTop?: number;
  marginBottom?: number;
  background?: string;
  code?: string;
}
export interface PromoBannerBlockProps {
  data: PromoBannerBlockData;
}
const PromoBannerBlock = ({
  data
}: PromoBannerBlockProps) => {
  const {
    title,
    description,
    ctaText = 'sprawdź',
    ctaLink = '#',
    image,
    video,
    imageAlt,
    labelType,
    reversed = false,
    marginTop,
    marginBottom,
    background,
    code
  } = data;
  const spacingBg = background || theme.rawColors.neutralWhite;
  const checkFlagActive = (flagName: TProductFlagsKey): boolean => {
    if (!labelType) return false;
    if (labelType === 'new') return flagName === FLAGS_TYPES_NAMES.novelty;
    if (labelType === 'bestseller') return flagName === FLAGS_TYPES_NAMES.bestseller;
    if (labelType === 'promotion') return flagName === FLAGS_TYPES_NAMES.promotion;
    return false;
  };
  return <>
      {Number(marginTop) > 0 && <SpacingBlock data={{
      type: 'spacingBlock',
      backgroundColor: spacingBg,
      height: String(Number(marginTop)),
      code: 'mt'
    }} />}
      <section sx={styles.section} data-testid={code}>
        <div sx={{
        ...styles.container,
        flexDirection: reversed ? ['column', 'column', 'row-reverse', 'row-reverse', 'row-reverse', 'row-reverse'] : ['column', 'column', 'row', 'row', 'row', 'row']
      }} data-testid="PromoBannerBlock-container">
          {/* Label */}
          {labelType && <PromoLabels configurable={false} pricePromoPercent="" checkFlagActive={checkFlagActive} isSmall={false} transparent={false} className="promo-label" isBlock={true} />}

          {/* Image / Video */}
          <div sx={styles.imageWrapper} data-testid="PromoBannerBlock-imageWrapper">
            {image && RenderMedia(image, video || undefined, true, undefined, imageAlt || title)}
          </div>

          {/* Content */}
          <div sx={{
          ...styles.contentWrapper,
          ...(background && {
            backgroundColor: background
          })
        }} data-testid="PromoBannerBlock-contentWrapper">
            <div sx={styles.content} data-testid="PromoBannerBlock-content">
              <p sx={styles.title}>{title}</p>
              {description && <p sx={styles.description}>
                  {splitTextByLineBreaks(description).map((line, index) => <Fragment key={index}>
                      {index > 0 ? <br /> : null}
                      {line}
                    </Fragment>)}
                </p>}
              {ctaText && ctaLink && <CtaButton text={ctaText} href={ctaLink} />}
            </div>
          </div>
        </div>
      </section>
      {Number(marginBottom) > 0 && <SpacingBlock data={{
      type: 'spacingBlock',
      backgroundColor: spacingBg,
      height: String(Number(marginBottom)),
      code: 'mb'
    }} />}
    </>;
};
export default PromoBannerBlock;